import { useEffect, useState, RefObject } from 'react'
import { useGeolocation } from '../useGeolocation'

export const useGooglePlacesAutocomplete = (
  searchRef: RefObject<HTMLInputElement | null>
) => {
  const { position } = useGeolocation()
  const [autocomplete, setAutocomplete] =
    useState<google.maps.places.Autocomplete>()
  const [waBounds] = useState<google.maps.LatLngBounds>(
    new window.google.maps.LatLngBounds()
  )

  useEffect(() => {
    if (searchRef) {
      waBounds.extend(new window.google.maps.LatLng(-34.922256, 112.771782))
      waBounds.extend(new window.google.maps.LatLng(-13.411688, 128.807354))
      const service: google.maps.places.Autocomplete =
        new window.google.maps.places.Autocomplete(
          searchRef?.current as HTMLInputElement,
          {
            componentRestrictions: { country: 'au' },
            bounds: waBounds,
            strictBounds: true
          }
        )
      setAutocomplete(service)
    }
  }, [searchRef])

  useEffect(() => {
    if (autocomplete && position) {
      const geolocation = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      }
      const service = new window.google.maps.DistanceMatrixService()
      service.getDistanceMatrix(
        {
          origins: [geolocation],
          destinations: [geolocation],
          travelMode: google.maps.TravelMode.DRIVING
        },
        function (response, status) {
          if (status === 'OK') {
            const distance = response?.rows[0].elements[0].distance.value
            const radius = (distance ?? 4000) / 2
            const circle = new google.maps.Circle({
              center: geolocation,
              radius: radius
            })
            const circleBounds = circle.getBounds()
            circleBounds && autocomplete.setBounds(circleBounds)
          } else {
            console.error('Error: ' + status)
          }
        }
      )
    }
  }, [autocomplete, position])

  return autocomplete
}
